import { Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { SkillmapComponent } from './skillmap-components/skillmap/skillmap.component';
import { SkillmapLearningComponent } from './skillmap-components/skillmap-learning/skillmap.component';
import { SkillmapLikeComponent } from './skillmap-components/skillmap-like/skillmap.component';
import { UploadListComponent } from './skillmap-components/upload-list/upload-list.component';
import { UploadXlsComponent } from './skillmap-components/upload-xls/upload-xls.component';
import { SkillTableComponent } from './skillmap-components/skill-table/skill-table.component';
import { SkillteamComponent } from './skillmap-components/skillteam/skillteam.component';
import { SkillteamActiveComponent } from './skillmap-components/skillteam-active/skillteam-active.component';
import { UserDetailTableComponent } from './skillmap-components/user-detail-table/user-detail-table.component';
import { TeamMatcherComponent } from './skillmap-components/team-matcher/team-matcher.component';
import { CreateTeamComponent } from './skillmap-components/create-team/create-team.component';

export const routes: Routes = [
  { path: '', component: DashboardComponent, canActivate: [AuthGuard] },
  {
    path: 'skillmap',
    children: [
      {
        path: 'graph',
        component: SkillmapComponent,
        pathMatch: 'full',
      },
      {
        path: 'graph-learning',
        component: SkillmapLearningComponent,
        pathMatch: 'full',
      },
      {
        path: 'graph-like',
        component: SkillmapLikeComponent,
        pathMatch: 'full',
      },
      {
        path: 'table',
        component: SkillTableComponent,
        pathMatch: 'full',
      },
      {
        path: 'teams',
        component: SkillteamComponent,
        pathMatch: 'full',
      },
      {
        path: 'active-teams',
        component: SkillteamActiveComponent,
        pathMatch: 'full',
      },
      {
        path: 'detail-user',
        component: UserDetailTableComponent,
        pathMatch: 'full',
      },
      {
        path: 'upload-list',
        component: UploadListComponent,
        pathMatch: 'full',
      },
      {
        path: 'upload',
        component: UploadXlsComponent,
        pathMatch: 'full',
      },
      {
        path: 'team-matcher',
        component: TeamMatcherComponent,
        pathMatch: 'full',
      },
      {
        path: 'create-team',
        component: CreateTeamComponent,
      },
    ],
    canActivate: [AuthGuard],
  },
];
